import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { subscriptionsAction, apiCallFailure } from 'app/actions';
import { api } from 'app/services';
import { KBPopover, KBForm, KBFormError, KBButton } from 'components';
import { renderKBInput } from 'components/formAdapters/reduxFormAdapters';
import { Field, FieldArray, reduxForm } from 'redux-form';

var ParkingCarPlatesForm = class extends React.Component {constructor(props) {super(props);this.updateCarPlatesForm = this.updateCarPlatesForm.bind(this);this.addNewCarPlate = this.addNewCarPlate.bind(this);this.renderCarPlates = this.renderCarPlates.bind(this);}updateCarPlatesForm(
  model) {
    const { sub_id, parking, updateSubscriptionAction } = this.props;

    delete model.name;
    let parking_area = {
      area_id: parking.area_id,
      car_plates: model.car_plates };

    model.car_plates = [];
    model.car_plates.push(parking_area);
    return api.putParkingContractCarPlates(sub_id, model).then(
    json => {
      updateSubscriptionAction.success(json);
      KBPopover.close();
    },
    error => {
      updateSubscriptionAction.failure(error);
      KBPopover.close();
    });

  }addNewCarPlate()

  {
    const { apiCallFailureActions } = this.props;
    const carPlatesFields = this.carPlatesFields;

    if (!carPlatesFields) {
      return;
    }

    if (carPlatesFields.length > 4) {
      return apiCallFailureActions({
        status: 'error',
        message: '每个车位最多只能添加 5 个车牌号' });

    }
    carPlatesFields.push({
      car_plate: '',
      driver_license: '',
      owner_name: '' });

  }renderCarPlates(
  { fields }) {
    this.carPlatesFields = fields;
    return (
      <div
      className="kb-row border"
      style={{ padding: 20, borderRadius: 4 }}>

        {fields.map((plate, index) => {
          return (
            <div
            key={plate}
            className="kb-form-group kb-form-48"
            style={{ width: '100%', position: 'relative' }}>

              <Field
              name={`${plate}.car_plate`}
              component={renderKBInput}
              title={`车牌号${index + 1}`}
              className="kb-form-group kb-form-c18" />

              <div className="kb-form-group kb-div-66">
                <Field
                name={`${plate}.driver_license`}
                component={renderKBInput}
                className="kb-form-group kb-div-210"
                title={`行驶证编号`} />

                <div className="kb-form-group kb-div-102">
                  <Field
                  name={`${plate}.owner_name`}
                  component={renderKBInput}
                  className="kb-form-group kb-div-210"
                  title={`行驶证所有者`} />

                  <i
                  className="iconfont icon-delete hover-delete"
                  style={{
                    position: 'absolute',
                    right: '13px',
                    bottom: '12px' }}

                  onClick={e => {
                    e.stopPropagation();
                    fields.remove(index);
                  }} />

                </div>
              </div>
            </div>);

        })}
        {fields.length > 4 ? null :
        <div
        className={`parking-car-plate-add-btn f-left ${
        fields.length > 0 ? 'm-top-sm' : ''
        }`}
        onClick={this.addNewCarPlate}>

            <i className="iconfont icon-add m-right-sm" />
            <span>添加车牌号</span>
          </div>}

      </div>);
  }render()

  {
    const {
      handleSubmit,
      submitting } =
    this.props;

    return (
      <KBForm
      type="reduxForm"
      onSubmit={handleSubmit(this.updateCarPlatesForm)}>

        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <h2 className="header-title">修改车牌号</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

          </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field
            name="name"
            component={renderKBInput}
            title="车位编号"
            className="kb-form-group kb-form-100 kb-form-alone"
            inputClass="kb-input-disabled"
            disabled={true} />

          </div>

          <FieldArray name="car_plates" component={this.renderCarPlates} />

          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定修改
            </KBButton>
          </div>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const { parking } = props;
  const { area, car_plates } = parking;

  return {
    initialValues: {
      name: area && area.name,
      car_plates,
      car_plates_saved: false } };


}

function mapDispatchToProps(dispatch) {
  return {
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch),
    updateSubscriptionAction: bindActionCreators(
    subscriptionsAction.update,
    dispatch) };


}

const validate = values => {
  const errors = {};

  return errors;
};

const formConfig = {
  form: 'ParkingCarPlatesForm',
  validate: validate,
  touchOnBlur: false };


ParkingCarPlatesForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(ParkingCarPlatesForm));

export default ParkingCarPlatesForm;
